import { mdiArrowCollapse } from '@mdi/js'
import Icon from '@mdi/react'
import { useAtom } from 'jotai'
import { ComponentProps, useCallback } from 'react'

import { Box } from '@/components/ui/box'
import { DrawerBackdrop, DrawerBody, DrawerContent, DrawerRoot } from '@/components/ui/drawer'
import useColorModeValue from '@/hooks/useColorModeValue'
import WidgetList from '@/pages/components/tasksApprovals/widgets'
import { isExpandedAtom, toggleMobiledrawer } from '@/store/tasksApprovals'

const MobileDrawer = () => {
    const [isOpen] = useAtom(isExpandedAtom)
    const onClose = () => {
        toggleMobiledrawer()
    }
    const onOpenChange = useCallback<NonNullable<ComponentProps<typeof DrawerRoot>['onOpenChange']>>((details) => {
        if (!details.open) {
            onClose?.()
        }
    }, [])

    return (
        <DrawerRoot open={isOpen} placement="end" size="xs" onOpenChange={onOpenChange}>
            <DrawerBackdrop mt="86px" bg={useColorModeValue('white', 'dark.800')} />
            <DrawerContent
                bg={useColorModeValue('surface.light', 'dark.900')}
                mt="86px"
                boxShadow="none"
                border="none"
                minW="200px"
                width="100%"
                maxW="290px"
            >
                <Box
                    position="absolute"
                    left="-50px"
                    top="5px"
                    borderRadius="50%"
                    backgroundColor={useColorModeValue('white', 'dark-900')}
                    padding="10px"
                    boxShadow="0px 0px 1px 5px rgba(84, 79, 64, 0.06)"
                    onClick={onClose}
                    cursor="pointer"
                >
                    <Icon path={mdiArrowCollapse} size="22px" />
                </Box>
                <DrawerBody p="0" pt="16px">
                    <WidgetList isExpanded={true} />
                </DrawerBody>
            </DrawerContent>
        </DrawerRoot>
    )
}

export default MobileDrawer
